import { useTranslation } from 'react-i18next';
import IntegrationsTable from 'pages/integrations/components/integrationTable/IntegrationsTable';
import { IntegrationCategory } from 'models/InternalIntegrationSetting';
import TabHeader from '../../components/tabHeader/TabHeader';

const IntegrationsGuestExperienceTab = () => {
  const { t } = useTranslation();

  return (
    <section>
      <TabHeader tabName={t('pageIntegrations.tabNames.guest-experience')} />
      <IntegrationsTable category={IntegrationCategory.GUEST_EXPERIENCE} />
    </section>
  );
};

export default IntegrationsGuestExperienceTab;
